import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND } from "@/lib/constants";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#book" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2" : "py-4"
      }`}
      style={{ backgroundColor: "#5C5654" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src={BRAND.logo}
            alt="FS Mountain Skills"
            className="h-12 w-12 md:h-14 md:w-14 object-cover rounded-md"
          />
          <div className="hidden sm:block leading-tight">
            <div
              className="font-display text-white text-lg font-semibold tracking-tight"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              FS Mountain Skills
            </div>
            <div className="text-[11px] tracking-[0.2em] uppercase text-[#3FB6B2]">
              Lancashire · Lake District
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-white/80 hover:text-white text-sm font-medium tracking-wide transition-colors"
            >
              {n.label}
            </a>
          ))}
          <a
            href="#book"
            data-testid="header-book-cta"
            className="rounded-full px-5 py-2.5 text-sm font-medium text-white transition-all"
            style={{ backgroundColor: "#3FB6B2" }}
          >
            Book a session
          </a>
        </nav>

        <button
          className="lg:hidden text-white p-2 rounded-md hover:bg-white/10"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-white/10"
          data-testid="mobile-menu"
        >
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-white/90 text-base"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={() => setOpen(false)}
              className="rounded-full px-5 py-3 text-sm font-medium text-white text-center"
              style={{ backgroundColor: "#3FB6B2" }}
              data-testid="mobile-book-cta"
            >
              Book a session
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
